import BannerContainer from "../../container/admin/banner-master";

const Banner = () => {
    return <BannerContainer />;
};

export default Banner;